import React, { RefObject } from "react";

interface BaseCheckboxState {
  id: string;
  name: string;
  label?: string;
  className?: string;
  /** 라벨(텍스트) 영역에만 적용할 클래스 > 선택지 텍스트 폭 고정 등에 사용 */
  labelClassName?: string;
  checked?: boolean;
  onChange?: (checked: boolean, e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  value?: string;
  wrap?: boolean;
  inputRef?: RefObject<HTMLInputElement>;
}

export const BaseCheckbox = (props: BaseCheckboxState) => {
  return (
    <div className={`${props.className ? props.className : ""}`}>
      <input
        ref={props.inputRef}
        id={props.id}
        type="checkbox"
        name={props.name}
        checked={props.checked}
        value={props.value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => props.onChange && props.onChange(e.target.checked, e)}
        disabled={props.disabled}
      ></input>
      <label htmlFor={props.id} className="flex-center">
        <div className="base-checkbox"></div>
        {props.label && (
          <span className={`ml8 font14 ${props.wrap ? "" : "no-wrap"} ${props.labelClassName ? props.labelClassName : ""}`}>{props.label}</span>
        )}
      </label>
    </div>
  );
};
